module.exports = __webpack_public_path__ + "img/forward.4f50d5b1.svg";